import React from 'react'
import { getMessage } from '../../../utils/index'
import './MarcadorForm.scss'
import { Card } from 'primereact/card'
import LtsInputText from '../../../components/lottus/lts-input-text'
import LtsTextArea from '../../../components/lottus/lts-text-area'
import { Checkbox } from 'primereact/checkbox'
import { TIPOS_MARCADOR } from '../../../constants'
import _ from 'lodash'

export const MarcadorForm = (props) => {
  const record = props.record
  const tipos = _.get(record, 'tipos', [])
  const messages = props.messages

  const tipoChecked = (idValue) => {
    const tipo = tipos.filter((tp) => tp === idValue.id)
    return !_.isEmpty(tipo)
  }

  const onChangeTipo = (checked, idValue) => {
    const newTipos = tipos.filter((t) => t !== idValue.id)
    if (checked) {
      newTipos.push(idValue.id)
    }
    props.setField('tipos', newTipos)
  }

  return (
    <div className="p-grid p-fluid">
      <div className="p-col-12">
        <Card title={getMessage(messages, 'marcador.label.marcador') + ' ' + record.oid || ''}>
          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-8 p-md-6 p-lg-4 p-xl-4">
              <LtsInputText
                value={record.codigo}
                onChange={(e) => props.setField('codigo', e)}
                name={'codigo'}
                label={getMessage(messages, 'marcador.label.codigo')}
              />
            </div>
          </div>
          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-12 p-md-10 p-lg-6 p-xl-6">
              <LtsTextArea
                value={record.descricao}
                onChange={(e) => props.setField('descricao', e)}
                name="descricao"
                label={getMessage(messages, 'marcador.label.descricao')}
              />
            </div>
          </div>

          {TIPOS_MARCADOR.map((tipo) => (
            <div className="p-grid form-group">
              <div className="p-col-12 p-sm-4 p-md-5 p-lg-3 p-xl-3">
                <Checkbox
                  checked={tipoChecked(tipo)}
                  onChange={(e) => onChangeTipo(e.checked, tipo)}
                  name={tipo.name}
                  style={{ marginRight: '5px' }}
                />
                <label htmlFor={tipo.name}>{tipo.value}</label>
              </div>
            </div>
          ))}

          <br />
          <div className="p-grid form-group">
            <div className="p-col-12 p-sm-4 p-md-3 p-lg-2 p-xl-2">
              <Checkbox
                checked={record.ativo}
                onChange={(e) => props.setField('ativo', _.get(e, 'checked', false))}
                name="ativo"
                style={{ marginRight: '5px' }}
              />
              <label htmlFor="chkativo">{getMessage(messages, 'marcador.label.ativo')}</label>
            </div>
          </div>
        </Card>
      </div>
    </div>
  )
}
